import React, { FC, useState } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';
import { DependencyTypeV2 } from '@eika-infrastruktur/mobilbank-lib/src/nativeProps';
import { RowButton } from '@eika/button';

import RowLink from '../../components/AccountDetailsView/RowLink';
import { EikaModal } from '../../components/EikaModal';
import { Content } from '../../components/shared/Content';
import useTranslation from '../../hooks/useTranslation';

const ThirdPartyDependencies: FC = () => {
    const translated = useTranslation();
    const { thirdPartyDependencies, thirdPartyDependenciesV2 } = useReactNativeProps();

    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [modalLicense, setModalLicense] = useState<DependencyTypeV2>();

    if (thirdPartyDependenciesV2) {
        return (
            <>
                <EikaModal
                    id="show-license__modal"
                    open={modalVisible}
                    setOpen={setModalVisible}
                    contentShouldStretch
                    onClose={() => setModalLicense(undefined)}
                >
                    <h2>{modalLicense?.licenseName}</h2>
                    <div>{modalLicense?.licenseContent}</div>
                </EikaModal>
                <Content>
                    <p>{translated.thirdPartyDependencies.description}</p>

                    {thirdPartyDependenciesV2
                        .filter((license: DependencyTypeV2) => !!license.licenseName)
                        .map((license: DependencyTypeV2) => (
                            <RowButton
                                key={license.licenseName}
                                className="settings__list-item remove-margin"
                                onClick={() => {
                                    setModalLicense(license);
                                    setModalVisible(true);
                                }}
                            >
                                {license.licenseName}
                            </RowButton>
                        ))}
                </Content>
            </>
        );
    }
    if (thirdPartyDependencies) {
        return (
            <Content>
                <p>{translated.thirdPartyDependencies.description}</p>
                {Object.entries(thirdPartyDependencies).map(([dependencyName, dependencyDetails]) => (
                    <React.Fragment key={dependencyName}>
                        {dependencyDetails.licenseUrl ? (
                            <RowLink className="settings__list-item remove-margin" href={dependencyDetails.licenseUrl}>
                                {dependencyName} ({dependencyDetails.licenses})
                            </RowLink>
                        ) : (
                            <div className="settings__list-item settings__list-item--third-party-dependencies">
                                {dependencyName} ({dependencyDetails.licenses})
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </Content>
        );
    }
    return <></>;
};

export default ThirdPartyDependencies;
